/**
 * Relative Imports
*/

import { EmoteProvider, EmoteIndicesTwitch } from './types';

/**
 * Locals
*/

const bttv: Record<string, string> = {};

/**
 * Public Functions
*/

/**
 * @param {string} word
 * @param {number} offset
 * @param {EmoteIndicesTwitch} emotes
 *
 * @return {string}
 */
export function EmoteId(
    word: string,
    offset: number,
    emotes: EmoteIndicesTwitch): string
{
    const target = `${ offset }-${ offset + length - 1 }`;

    for (const emoteid in emotes)
    {
        for (const indices of emotes[emoteid])
        {
            if (target === indices)
            {
                return emoteid;
            }
        }
    }

    return EmoteIdBTTV(word);
}

/**
 * Returns the id of the BTTV emote for the given word.
 *
 * @param {string} word
 *
 * @return {string}
 */
export function EmoteIdBTTV(
    word: string): string
{
    return bttv[word] ?? null;
}

/**
 * @return {string}
 */
export function EmoteURL(
    emoteid: string,
    size: '1' | '2' | '3' = '3',
    provider: EmoteProvider = EmoteProvider.Twitch): string
{
    switch (provider)
    {
    case EmoteProvider.Twitch:
        return `https://static-cdn.jtvnw.net/emoticons/v2/${ emoteid }/default/dark/${ size }.0`;
    case EmoteProvider.BTTV:
        return `https://cdn.betterttv.net/emote/${ emoteid }/${ size }x`;
    }
}

/**
 * @param {string} twitchid
 *
 * @return {Promise<void>}
 */
 export function EmoteInitBTTV(
    twitchid: string): Promise<void>
{
    return new Promise(async resolve => {
        const response = await fetch(`https://api.betterttv.net/3/cached/users/twitch/${ twitchid }`);
        const json = await response.json();

        for (const emote of json.channelEmotes)
        {
            bttv[emote.code.toLowerCase()] = emote.id;
        }

        for (const emote of json.sharedEmotes)
        {
            bttv[emote.code.toLowerCase()] = emote.id;
        }

        resolve();
    });
}
